import {useRef} from "react";
import {Button, TextField} from "@mui/material";
import {Send} from "@mui/icons-material";
import Box from "@mui/material/Box";
import useAlert from "../../../../../use/useAlert";
import useArtisanCommentRepository from "../../../../../repository/b2c/useArtisanCommentRepository";

const COMPANY_COMMENT_REQUIRED = "Le champs est vide";

export default function ({interventionId, onSuccess}) {
    const alert = useAlert();
    const artisanCommentRepository = useArtisanCommentRepository();
    const companyCommentInput = useRef();

    const submit = async () => {
        if (companyCommentInput.current.value.length === 0) {
            alert.warning(COMPANY_COMMENT_REQUIRED);
            return;
        }

        const id = await artisanCommentRepository.create({
            artisan_comment: {
                content: companyCommentInput.current.value,
                intervention_id: interventionId
            }
        });

        if (typeof id === "number") onSuccess();
    }

    return (
        <div data-test="let-message-modal">
            <div>
                <TextField
                    fullWidth
                    variant={"standard"}
                    multiline
                    minRows={6}
                    maxRows={8}
                    label={"Transmettre une information"}
                    inputRef={companyCommentInput}
                    data-test="textarea-company-comment"
                />
            </div>
            <Box mt={2}>
                <Button
                    startIcon={<Send/>}
                    variant="contained"
                    size={"large"}
                    fullWidth
                    onClick={submit}
                    data-test="button-send-message"
                >
                    Envoyer
                </Button>
            </Box>
        </div>
    )
}